"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelationshipToProbandEnum = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.RelationshipToProbandEnum = {
    IsProband: 'is proband',
    Self: 'self',
    SiblingOf: 'sibling of',
    TwinOf: 'twin of',
    MaternalHalfSiblingOf: 'maternal half-sibling of',
    PaternalHalfSiblingOf: 'paternal half-sibling of',
    HalfSiblingOf: 'half-sibling of',
    ChildOf: 'child of',
    ParentOf: 'parent of',
    NieceNephewOf: 'niece/nephew of',
    UncleAuntOf: 'uncle/aunt of',
    CousinOf: 'cousin of',
    GrandchildOf: 'grandchild of',
    GrandparentOf: 'grandparent of',
    PartnerOf: 'partner of',
    RelativeOf: 'relative of'
};
